import { useGoogleTagManager } from '@hooks/use-google-tag-manager/use-google-tag-manager';

import { GoogleTagManagerProviderProps } from './google-tag-manager.type';
import { GoogleTagManagerContext } from './google-tag-manager-context';

export const GoogleTagManagerProvider = ({ children }: GoogleTagManagerProviderProps) => {
  const gtm = useGoogleTagManager();

  return <GoogleTagManagerContext.Provider value={gtm}>{children}</GoogleTagManagerContext.Provider>;
};
